// src/components/SendReminderButton.tsx
import { useState } from "react";
import { Bell, Loader2, Check } from "lucide-react";
import { supabase } from "../supabaseClient";

type Status = "idle" | "sending" | "sent" | "error";

export default function SendReminderButton({
  type,
  eventId,
}: {
  type: "match" | "training";
  eventId: string;
}) {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  async function handleClick() {
    if (status === "sending") return;
    setStatus("sending");
    setMessage("");

    try {
      const { data, error } = await supabase.functions.invoke("send_event_reminder", {
        body: { type, eventId },
      });
      if (error) throw error;

      const sent = data?.sent ?? 0;
      setStatus("sent");
      setMessage(
        sent > 0
          ? `Rappel envoyé à ${sent} personne${sent > 1 ? "s" : ""}.`
          : "Aucun destinataire n'a activé les notifications."
      );
    } catch (err: any) {
      setStatus("error");
      setMessage(err?.message || "Erreur lors de l'envoi du rappel.");
    } finally {
      setTimeout(() => setStatus("idle"), 4000);
    }
  }

  return (
    <div className="inline-flex flex-col items-end gap-1">
      <button
        type="button"
        onClick={handleClick}
        disabled={status === "sending"}
        className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-full border border-gray-200 dark:border-gray-800
                   text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 transition disabled:opacity-60"
      >
        {status === "sending" ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : status === "sent" ? (
          <Check className="h-3.5 w-3.5" />
        ) : (
          <Bell className="h-3.5 w-3.5" />
        )}
        Envoyer un rappel
      </button>
      {message && (
        <span
          className={`text-xs max-w-[220px] text-right ${
            status === "error" ? "text-red-600 dark:text-red-400" : "text-gray-500 dark:text-gray-400"
          }`}
        >
          {message}
        </span>
      )}
    </div>
  );
}
